module.exports = __webpack_public_path__ + "d7ff6bea76bfec967ffd8c90e90e91c6.png";